/**
 * Slider Component
 *
 * @file slider.js
 */

// Swiper'ı ve gerekli CSS dosyalarını içe aktar
// import Swiper from 'swiper';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Mousewheel } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';
import 'swiper/css/mousewheel';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const fullSliderC = new Swiper('.home-slide', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      loopAdditionalSlides: 0,
      autoplay: {
        delay: 5000, // 3 saniyede bir otomatik geçiş
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".home-slide-next",
        prevEl: ".home-slide-prev",
      },
      pagination: {
        el: ".home-slide-pagination",
      },
    });
  };
  
  const homeHelpSlide = () => {
    const homeHelpSlide = new Swiper('.hm-help-carousel', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next",
        prevEl: ".hm-help-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide1 = new Swiper('.hm-help-carousel-1', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-1",
        prevEl: ".hm-help-prev-1",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide2 = new Swiper('.hm-help-carousel-2', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-2",
        prevEl: ".hm-help-prev-2",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide3 = new Swiper('.hm-help-carousel-3', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-3",
        prevEl: ".hm-help-prev-3",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide4 = new Swiper('.hm-help-carousel-4', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-4",
        prevEl: ".hm-help-prev-4",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide5 = new Swiper('.hm-help-carousel-5', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-5",
        prevEl: ".hm-help-prev-5",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeHelpSlide6 = new Swiper('.hm-help-carousel-6', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-help-next-6",
        prevEl: ".hm-help-prev-6",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    // $(".a-tab-item").on("click", function(){
    //     homeHelpSlide.update();
    //     homeHelpSlide1.update();
    // });
  };
  
  const homeNewsSlide = () => {
    if($('.hm-news-carousel .swiper-slide').length < 4){
      $('.hm-news-carousel .swiper-wrapper').addClass('justify-center flex');
    }
    if($('.hm-news-carousel-1 .swiper-slide').length < 4){
      $('.hm-news-carousel-1 .swiper-wrapper').addClass('justify-center flex');
    }
    const homeNewsSlide = new Swiper('.hm-news-carousel', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      observer: true,
      observeParents: true,
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: ".hm-news-next",
        prevEl: ".hm-news-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1260: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    const homeNewsSlide1 = new Swiper('.hm-news-carousel-1', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      observer: true,
      observeParents: true,
      slidesPerView: 4,
      spaceBetween: 30,
    loop: true,
    loopAdditionalSlides: 0,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".hm-news-next-1",
      prevEl: ".hm-news-prev-1",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1260: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      },
    });
    // $(".b-tab-item").on("click", function(){
    //   homeNewsSlide.update();
    //   homeNewsSlide1.update();
    // });
  };
  
  const dhSlide = () => {
    const dhSlide = new Swiper('.dh-carousel', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 0,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: ".dh-slide-pagination",
        clickable: true,
      },
    });
  };

  const familyMemberAccordion = () => {
    const familyMemberAccordion = document.getElementsByClassName('family-member-accordion');
    const dhCarousel = document.querySelector('.dh-carousel');
    
    // dh-carousel slider instance'ını al
    let dhSlideInstance = null;
    if (dhCarousel && dhCarousel.swiper) {
      dhSlideInstance = dhCarousel.swiper;
    }
    
    for (let i = 0; i < familyMemberAccordion.length; i += 1) {
      familyMemberAccordion[i].addEventListener('click', function (event) {
        // Diğer açık accordionları kapat
        for (let j = 0; j < familyMemberAccordion.length; j += 1) {
          if (familyMemberAccordion[j] !== this) {
            familyMemberAccordion[j].classList.remove('js-active');
            const otherDescription = familyMemberAccordion[j].nextElementSibling;
            if (otherDescription) {
              otherDescription.classList.remove('js-active');
            }
          }
        }
        
        // Tıklanan accordionu aç/kapat
        event.currentTarget.classList.toggle('js-active');
        const familyMemberAccordionDescription = this.nextElementSibling;
        familyMemberAccordionDescription.classList.toggle('js-active');
        
        // dh-carousel slider'ını tıklanan index'e götür
        if (dhSlideInstance) {
          dhSlideInstance.slideTo(i);
        }
      });
    }
  };
  
  const init = () => {
    fullSlider();
    homeHelpSlide();
    homeNewsSlide();
    dhSlide();
    familyMemberAccordion();
  };

  return {
    init,
  };
})();

export default slider;
